import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import bookConsultationIcon from '../../../assets/icons/book-consultation.svg';
import nirvaLogo from '../../../assets/images/LOGO_NIRVA.svg';
import { CONSULTATION_COPY } from '../../../constants/consultation';
import { openSimplePracticeClientPortal } from '../../../utils/simplePractice';

export const HERO_CONTENT = {
  overHeading: 'READY TO CONNECT?',
  heading: 'Contact Nirva',
  subtext:
    'Thank you for your interest in Nirva – Interpersonal Hypnotherapy Clinic. Please use the contact form on this page to reach our team. We typically respond within one business day (or the next business day after weekend and holiday inquiries).',
  containedButtonText: 'Get in Touch',
  outlinedButtonText: 'Contact Form',
  externalText:
    'Important: This form is not for emergencies and is PHI-free by design.\n Please do not include medical details, diagnoses, or crisis information.\n If you are in immediate danger or crisis, call 911 or your local emergency number.',
};

export const ACTION_CARD_CONTENTS = {
  BOOK_CONSULTATION: {
    title: CONSULTATION_COPY.bookA,
    description: `Schedule a <b>30-minute free, confidential consultation</b> with one of our compassionate, certified practitioners. We’ll take time to understand your goals and help you explore how hypnosis can support positive change in your life.`,
    image: bookConsultationIcon,
    imageAlt: CONSULTATION_COPY.bookA,
    buttonText: CONSULTATION_COPY.start,
  },
  CLIENT_PORTAL: {
    title: 'Client Portal',
    subtitle: 'Already a client?',
    description:
      'Access Nirva’s secure SimplePractice Client Portal to complete intake forms, review and sign documents, manage appointments, send secure messages, and join your telehealth sessions.',
    image: nirvaLogo,
    imageAlt: 'Nirva – Interpersonal Hypnotherapy Clinic',
    // The circular clip is meant for the round emblem this replaced; the Nirva
    // lockup is wide and would lose its wordmark.
    rounded: false,
    buttonText: 'Access Client Portal',
    onClick: openSimplePracticeClientPortal,
  },
};

export const CONTACT_FORM_CONTENT = {
  INQUIRIES: {
    title: 'General Inquiries',
    subtitle: 'Have a question or request?',
    text: 'Fill out our brief contact form, and we’ll respond within 24 hours on weekdays or by the next business day for weekend inquiries.',
  },
  HOURS: {
    title: 'Office Hours',
    text: 'Monday – Friday: 9:00 AM – 6:00 PM\nSaturday: By Appointment\nSunday: By Appointment',
  },
  REACH_OUT: {
    title: 'Ready to Reach Out?',
    text: 'Send us a message and a member of our team will get back to you within one business day.',
    buttonText: 'Contact Our Team',
    note: 'This form is PHI-free by design —\nplease don’t include medical details.\nIf you are in crisis, call 911 or 988.',
  },
  FORM: {
    name: {
      label: 'Full Name *',
      icon: <PersonOutlineOutlinedIcon fontSize="medium" />,
    },
    email: {
      label: 'Email Address *',
      icon: <EmailOutlinedIcon fontSize="medium" />,
    },
    phone: {
      label: 'Phone Number (optional)',
      icon: <PhoneOutlinedIcon fontSize="medium" />,
    },
    message: {
      label: 'Message / Question *',
      icon: <ChatOutlinedIcon fontSize="medium" />,
    },
    contact: {
      label: 'Preferred Contact Method',
      icon: <InboxOutlinedIcon fontSize="medium" />,
    },
    buttonText: 'Explore Our Services',
  },
  CONSENT_TEXT:
    'By submitting this form, you agree to our <a href="http://nirvaiphc.s3-website-us-east-1.amazonaws.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a> and Website <a href="http://nirvaiphc.s3-website-us-east-1.amazonaws.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and consent to receive email responses from Nirva. You may request to stop communication at any time.',
};
